module.exports = __webpack_public_path__ + "01_short_black.4b5fe950.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/nakagawa/boy/layer5/01_short_black.png
// module id = rmil
// module chunks = 0